import classNames from 'classnames';
import PropTypes from 'prop-types';
import { SEARCH_THUMBNAIL_IMAGE, renderImage } from 'helpers/ImageHelper';
import { getSitePlatform } from 'helpers/BreakpointHelper';

const TileImage = ({ altText = '', image, name, rendered = false, Style }) => {
  const imageTagClasses = [Style.image];
  const tileImage = renderImage({
    alt: altText || name,
    breakpoint: getSitePlatform(),
    className: classNames(imageTagClasses),
    dataTest: 'tile-image',
    imageType: SEARCH_THUMBNAIL_IMAGE,
    style: {
      background:
        'linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0, rgba(0, 0, 0, 0) 80%, rgba(0, 0, 0, 0))',
    },
    src: image,
  });
  return tileImage;
};

TileImage.propTypes = {
  altText: PropTypes.string,
  image: PropTypes.string.isRequired,
  isHover: PropTypes.bool,
  name: PropTypes.string,
  rendered: PropTypes.bool.isRequired,
  Style: PropTypes.shape({}),
};

export default TileImage;
